.docs-nav-backdrop {
  visibility: hidden;
  pointer-events: none;
  user-select: none;
  touch-action: manipulation;
  background-color: var(--ld-col-neutral-900);
  opacity: 0;
  z-index: 1;

  @media (width <= 52rem) {
    transition: opacity 0.2s linear, visibility 0s 0.2s linear;
    position: fixed;
    width: 100%;
    height: 100%;
  }
}

.docs-nav-backdrop__a {
  position: fixed;
  width: 100%;
  height: 100%;
  user-select: none;
  touch-action: manipulation;
}
